import { RootState } from "../../../_config/redux"

const authSelector = (state: RootState): RootState['auth'] => state.auth

export const selectIsLoggedIn = (state: RootState) => {
    const { isLoggedIn } = authSelector(state);
    return isLoggedIn;
}

export const selectIsLoadingAuth = (state: RootState) => {
    const { loading } = authSelector(state);
    return loading === 'pending';
}

export const selectAuthErrors = (state: RootState) => {
    const { errors } = authSelector(state);
    return errors;
}

export const selectLoggedInUser = (state: RootState) => {
    const { user } = authSelector(state);
    return user;
}